import React from 'react';

import LinkedinButton from 'components/LinkedinButton/LinkedinButton';

import styles from './LinkedinVerification.module.scss';

const LinkedinVerification = ({ onSubmit }) => {
  return (
    <div className={styles.linkedinVerification}>
      <img src="assets/images/linkedin-and-checkmate.png" alt="illustration" />
      <p className="primary-text u-font-size-xxxx-large u-margin-top">
        Before we start, let’s confirm your identity
      </p>
      <p className="secondary-text u-font-size">
        We offer a convenient option to verify using LinkedIn.
      </p>
      <p className={styles.note}>*We do not use your information for any other purposes</p>
      <LinkedinButton />
      <a onClick={() => onSubmit('')}>Continue without LinkedIn</a>
    </div>
  );
};

export default LinkedinVerification;
